import React, { useEffect, useState } from "react"
import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Form,
  Input,
  Label,
} from "reactstrap"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"

import ReactSelect from "react-select"
import Select from "react-select"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"

// common component
import NewPagination from "components/Common/Newpagination"
import cheque from "../../../../assets/images/cheque.jpg"

// Hover card
import ProfileDetails from "components/Common/ProfileDetails"
import axios, { Axios } from "axios"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"

import configure from "configure"
import Swal from "sweetalert2"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import moment from "moment"
import { current } from "@reduxjs/toolkit"
import { CSVLink } from "react-csv"
import "../../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
import Draggable, { DraggableCore } from "react-draggable"
import { Resizable, ResizableBox } from "react-resizable"
// import BlankPdf from "../../../../assets/pdf/blank.pdf"
import BlankPdf from "../../../../assets/pdf/blank.pdf"


function TableContainer({ columns, data }) {
  const [fixedContent, setFixedContent] = useState(false)
  const [addCheque, setAddCheque] = useState(false)

  const [formPopup, setFormPopup] = useState(false)

  const month_option = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
  ]
  const year_option = [
    { label: "2024", value: "2024" },
    { label: "2023", value: "2023" },
    { label: "2022", value: "2022" },
    { label: "2021", value: "2021" },
  ]

  const navigate = useNavigate()

  //   document.addEventListener("keydown", e => {
  //     if (e.key === "Escape")
  //   })

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )
  const { pageIndex, pageSize, globalFilter } = state

  useEffect(() => setPageSize(50), [])

  const excelColumns = []
  columns.forEach(column => {
    column.Header !== "Action" && excelColumns.push(column.Header)
  })

  const csvData = [
    excelColumns,
    ...data.map(
      ({
        id,
        date,
        title,
        invoiceNo,
        customer,
        tdsReceive,
        category,
        debit,
        credit,
      }) => [
        id,
        date,
        title,
        invoiceNo,
        customer,
        tdsReceive,
        category,
        debit,
        credit,
      ]
    ),
  ]

  // Render the UI for your table
  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-4 mt-3 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        {/* <Link className="btn btn-save  fix-btn btn-label pe-0">
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Bank Sheet</span>
        </Link> */}
        <a
          className="btn btn-save  fix-btn btn-label pe-0"
          title="Download"
          href={BlankPdf}
          target="_blank"
          rel="noreferrer"
          download
        >
          <i className="fas fa-download me-2 icon-size label-icon"></i>
          Bank Sheet

        </a>

        <button
          onClick={() => navigate(-1)}
          className="btn btn-red  fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>

      {/* <Row className="mb-4">
      </Row> */}
      <Row className="d-flex mt-4">
        <div className="d-flex col-md-6 col-sm-4 justify-flex-start align-items-center gap-2">
          <div className="col-sm-4 budget_status text-success pt-2 px-0 me-5 rounded proposal-status text-center d-flex justify-content-center align-items-center gap-2">
            <h4>Total Employees :</h4>
            <h3>₹ 11</h3>
          </div>

          <div className="col-sm-4 budget_status text-primary pt-2 px-2 me-5 rounded proposal-status text-center d-flex justify-content-center align-items-center gap-2">
            <h4>Total Amount :</h4>
            <h3>₹ 10,540</h3>
          </div>
        </div>

        <div className="col-md-6 col-sm-8 text-end">
          <div className="d-flex gap-2 justify-content-end align-items-end">
            <CSVLink
              className="border-radius btn text-white me-2 btn-success btn-label"
              filename="tds_zithas.csv"
              data={csvData}
            >
              <i className="fas fa-download me-2 icon-size label-icon"></i>{" "}
              Export CSV
            </CSVLink>
            <button
              className=" btn btn-save btn-label"
              onClick={() => setAddCheque(true)}
            >
              <i className="fas fa-plus me-2 label-icon"></i>
              Add Cheque Number
            </button>
            {/* <button
              className=" btn btn-save btn-label"
            
            >
              <i className="fas fa-download me-2 label-icon"></i>
              Bank Sheet
            </button> */}
            <a
              className="s btn text-white me-2 btn-save btn-label"
              title="Download"
              href={BlankPdf}
              target="_blank"
              rel="noreferrer"
              download
            >
              <i className="fas fa-download me-2 icon-size label-icon"></i>
              Bank Sheet

            </a>
          </div>
        </div>
      </Row>
      <Row className="m-0 d-flex justify-space-between align-items-center">
        <div className="p-0 col-md-2 mb-3">
          <select
            className=" form-select mt-4"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 25, 50, 100].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div className="p-0 col-md-2 d-flex">
        <div className="search-box my-xxl-0 d-inline-block d-flex flex-row justify-content-center align-items-center">
            <button
              onClick={() => setFormPopup(!formPopup)}
              className="btn btn-outline-secondary  me-3"
            >
              <i className="fas fa-filter"></i>
            </button>
            <div className="position-relative mt-4 mb-3">
              <label htmlFor="search-bar-0" className="search-label">
                <span id="search-bar-0-label" className="sr-only">
                  Search this table
                </span>
                <input
                  onChange={e => setGlobalFilter(e.target.value)}
                  id="search-bar-0"
                  type="text"
                  className=" form-control rounded h-100 "
                  placeholder={` Search...`}
                  value={globalFilter || ""}
                />
              </label>
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </div>
        </div>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${
              fixedContent ? "fixed-bank-mng-header" : "fix-table-header"
            } `}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className
                  return (
                    <th
                      key={index}
                      className={` col-t-${index + 1} ${classNames}`}
                      // {...column.getHeaderProps()}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div
                        className={`position-relative d-flex ${
                          column.isShortIcon
                            ? "justify-content-between"
                            : "justify-content-center"
                        }`}
                      >
                        {/* {index === 0 && <span></span>} */}
                        <span>
                          {column.render("Header")}
                        </span>
                        {column.isShortIcon ? (
                          <span
                            style={{
                              position: index != 0 ? "absolute" : "",
                              right: index != 0 ? "0" : "",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${
                                column.isSorted && !column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${
                                column.isSorted && column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                          </span>
                        ) : null}
                      </div>
                    </th>
                  )
                })}
              </tr>
            ))}
          </thead>

          <tbody className="fix-bank-table-body" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              const { did_col: did, pwd_col: pwd } = row.original
              const status = row.original.status_name

              let backgroundStyle = {}

              const priority = row.original.priority_col

              return (
                <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                  {row.cells.map((cell, index) => (
                    <td
                      key={index}
                      className={`t-col-${index + 1} ${cell.column.className} ${
                        priority == "High" ? "highPriority" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPag={canPreviousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
        />
      </Row>

      {formPopup ? (
        <div id="Bank-filter">
          <div className="Bank-popup-form p-4">
            <Form
              onSubmit={e => {
                e.preventDefault()
              }}
            >
              <Row className="align-items-end">
                <Row className="d-flex pe-0 me-0" style={{ width: "100%" }}>
                  <div className="col-md-3 mt-2">
                    <label htmlFor="">Month</label>
                    <Select
                      placeholder="Select Month"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      // styles={colourStyles}
                      options={month_option}
                      closeMenuOnSelect={false}
                    />
                  </div>
                  <div className="col-md-3 mt-2">
                    <label htmlFor="">Year</label>
                    <Select
                      placeholder="Select Year"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      // styles={colourStyles}
                      options={year_option}
                      closeMenuOnSelect={false}
                    />
                  </div>

                  <div className="col-md-3 mt-2">
                    <label htmlFor="">Save and Clear Filters</label>
                    <div>
                      <a
                        className="btn  btn-primary mr-10"
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#93a6ff",
                          borderColor: "#93a6ff",
                          color: "black",
                        }}
                      >
                        Save Filters
                      </a>
                      <a
                        className="btn  btn-danger"
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#fed36d",
                          borderColor: "#fed36d",
                          color: "black",
                        }}
                      >
                        Clear Filters
                      </a>
                    </div>
                  </div>
                  <div className="d-flex col-md-3 mb-1 align-items-end justify-content-end">
                    <div className="mr-10">
                      <button className="btn  btn-purple">
                        <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                        Filter
                      </button>
                    </div>
                    <div className="">
                      <a
                        className="btn  btn-red"
                        onClick={() => setFormPopup(false)}
                      >
                        <i className="dripicons-cross me-1 icon-center"></i>{" "}
                        Close
                      </a>
                    </div>
                  </div>
                </Row>
              </Row>
            </Form>
            <i className="bi bi-triangle-fill pop-icon"></i>
          </div>
        </div>
      ) : null}
      {/* Renew Project  */}
      <div className={`note-sticky-form ${addCheque ? "d-block" : "d-none"}`}>
        <Draggable>
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "30%",
              right: "30%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Add Cheque Number</h5>
            </div>

            <div className="modal-body pe-4">
              <Form
                // onSubmit={handleEditSubmit}
                className="row d-flex justify-content-center align-items-center"
              >
                <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
                  <div className="text-center">
                    <img src={cheque} alt="Addepe" style={{ width: "90%" }} />
                  </div>
                </div>

                <div className="col-md-7 d-flex flex-column ">
                  <div className="col-12 d-flex flex-column mb-3 ">
                    <label htmlFor="">
                      Cheque No. <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>

                  <div className="mt-4 text-end">
                    <button className=" btn btn-save btn-label">
                      <i className="fas fa-save me-2 label-icon"></i>
                      Save
                    </button>
                    <a
                      onClick={() => setAddCheque(false)}
                      className=" btn ms-md-2 btn-red btn-label"
                    >
                      <i className="dripicons-cross me-2 icon-center label-icon"></i>
                      CANCEL
                    </a>
                  </div>
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </div>
  )
}
// function TableContainer({ columns, data }) {
//     const [fixedContent, setFixedContent] = useState(false)
//     const [formPopup, setFormPopup] = useState(false)

//     // const [salaryCalculation, setSalaryCalculation] = useState(false);

//     const navigate = useNavigate()

//     document.addEventListener("scroll", () => {
//       if (window.scrollY > 256) {
//         setFixedContent(true)
//       } else {
//         setFixedContent(false)
//       }
//     })

//     // Use the state and functions returned from useTable to build your UI
//     const {
//       getTableProps,
//       getTableBodyProps,
//       headerGroups,
//       page,
//       state,
//       previousPage,
//       nextPage,
//       canPreviousPage,
//       canNextPage,
//       gotoPage,
//       setPageSize,
//       pageOptions,
//       setGlobalFilter,
//       pageCount,
//       prepareRow,
//     } = useTable(
//       {
//         columns,
//         data,
//         initialState: {
//           sortBy: [
//             {
//               id: "id", // Set the ID of the first column for default sorting
//               desc: true, // `true` for descending, `false` for ascending
//             },
//           ],
//         },
//       },

//       useGlobalFilter,
//       useSortBy,
//       usePagination
//     )

//     const { pageIndex, pageSize, globalFilter } = state

//     // Functionality to export table data to CSV //
//     const excelColumns = []
//     columns.forEach(column => {
//       excelColumns.push(column.Header)
//     })

//     const csvData = [
//       excelColumns,
//       ...data.map(
//         ({ id, date, title, invoiceNo, customer, category, debit, credit }) => [
//           id,
//           date,
//           title,
//           invoiceNo,
//           customer,
//           category,
//           debit,
//           credit,
//         ]
//       ),
//     ]
//     // ======================================================= //

//     const handleSalaryCalculation = async () => {
//       Swal.fire({
//         title: "Are you sure to calculate salary?",
//         icon: "warning",
//         text: "if confirm then it will take around 1 to 2 minutes. please don't refresh the page",
//         showCancelButton: true,
//         confirmButtonText: "Confirm",
//       }).then(willOkay => {
//         if (willOkay.isConfirmed) {
//           Swal.fire({
//             icon: "success",
//             text: "Calculation Successfully Completed",
//           })
//         }
//       })
//     }

//     const handleAccessPreview = async () => {
//       Swal.fire({
//         title: "Are you sure?",
//         icon: "warning",
//         text: "Are you sure you want grant access punching preview to employees ?",
//         showCancelButton: true,
//         confirmButtonText: "Confirm",
//       }).then(willOkay => {
//         if (willOkay.isConfirmed) {
//           Swal.fire({
//             icon: "success",
//             text: "Punching preview is granted for employees",
//           })
//         }
//       })
//     }

//     // Render the UI for your table
//     return (
//       <div>
//         <Row className="mb-2">
//           <Col>
//             <select
//               className="border-radius form-select"
//               style={{ width: "100px" }}
//               value={pageSize}
//               onChange={e => setPageSize(e.target.value)}
//             >
//               {[10, 20, 30, 40, 50].map(pageSize => (
//                 <option key={pageSize} value={pageSize}>
//                   Show {50}
//                 </option>
//               ))}
//             </select>
//           </Col>
//           <Col md={8} className="d-flex justify-content-end">
//             <div className="">
//               <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
//                 <div className="position-relative">
//                   <label htmlFor="search-bar-0" className="search-label">
//                     <span id="search-bar-0-label" className="sr-only">
//                       Search this table
//                     </span>
//                     <input
//                       onChange={e => setGlobalFilter(e.target.value)}
//                       id="search-bar-0"
//                       type="text"
//                       className="border-radius form-control rounded h-100"
//                       placeholder={` Search...`}
//                       value={globalFilter || ""}
//                     />
//                   </label>
//                   <i className="bx bx-search-alt search-icon"></i>
//                 </div>
//               </div>
//             </div>
//             <div></div>
//           </Col>
//         </Row>

//         <div className="position-relative">
//           {/* <Table className='table table-bordered mt-3' {...getTableProps()}>
//                       <thead className={`${fixedContent ? 'fixed-setting-header' : ''} fix-gst-header`}>
//                           {
//                               headerGroups.map((headerGroup, i) => (
//                                   <tr key={i} {...headerGroup.getHeaderGroupProps()}>
//                                       {
//                                           headerGroup.headers.map((column, index) => (
//                                               <th key={index} className={`t-col-${index + 1} ${column.className}`} {...column.getHeaderProps()}>{column.render("Header")}

//                                               </th>
//                                           ))
//                                       }
//                                   </tr>
//                               ))
//                           }
//                       </thead>

//                       <tbody className="fix-gst-header" {...getTableBodyProps()}>
//                           {
//                               page.map((row, i) => {
//                                   prepareRow(row);
//                                   return (
//                                       <tr className='row-hover' {...row.getRowProps()} key={i}>
//                                           {
//                                               row.cells.map((cell, index) => {
//                                                   return <td key={index} className={`t-col-${index + 1} ${cell.column.className}`} {...cell.getCellProps()}>{cell.render("Cell")}</td>;
//                                               })
//                                           }
//                                       </tr>
//                                   );
//                               })
//                           }
//                       </tbody>
//                   </Table> */}
//           <Table className="table table-bordered" {...getTableProps()}>
//             <thead
//               className={`${
//                 fixedContent ? "fixed-leave-mng-header" : "fix-table-header"
//               } `}
//             >
//               {headerGroups.map((headerGroup, i) => (
//                 <tr key={i} {...headerGroup.getHeaderGroupProps()}>
//                   {headerGroup.headers.map((column, index) => {
//                     const classNames = column.className
//                     return (
//                       <th
//                         key={index}
//                         className={` col-t-${index + 1} ${classNames}`}
//                         // {...column.getHeaderProps()}
//                         {...column.getHeaderProps(column.getSortByToggleProps())}
//                       >
//                         <div
//                           className={`position-relative d-flex ${
//                             column.isShortIcon
//                               ? "justify-content-between"
//                               : "justify-content-center"
//                           }`}
//                         >
//                           {index === 0 && <span></span>}
//                           <span
//                             style={{
//                               position: index === 0 ? "absolute" : "",
//                               left: index === 0 ? "45%" : "",
//                             }}
//                           >
//                             {column.render("Header")}
//                           </span>
//                           {column.isShortIcon ? (
//                             <span
//                               style={{
//                                 position: index != 0 ? "absolute" : "",
//                                 right: index != 0 ? "0" : "",
//                               }}
//                               onClick={() =>
//                                 column.getSortByToggleProps().onClick()
//                               }
//                             >
//                               <i
//                                 title="Ascending"
//                                 className={`bi bi-arrow-up ms-1 info-icon ${
//                                   column.isSorted && !column.isSortedDesc
//                                     ? "text-dark"
//                                     : ""
//                                 }`}
//                               ></i>
//                               <i
//                                 title="Descending"
//                                 className={`bi bi-arrow-down info-icon ${
//                                   column.isSorted && column.isSortedDesc
//                                     ? "text-dark"
//                                     : ""
//                                 }`}
//                               ></i>
//                             </span>
//                           ) : null}
//                         </div>
//                       </th>
//                     )
//                   })}
//                 </tr>
//               ))}
//             </thead>

//             <tbody className="fix-leave-table-body" {...getTableBodyProps()}>
//               {page.map((row, i) => {
//                 prepareRow(row)
//                 const { did_col: did, pwd_col: pwd } = row.original
//                 const status = row.original.status_name

//                 let backgroundStyle = {}

//                 const priority = row.original.priority_col

//                 return (
//                   <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
//                     {row.cells.map((cell, index) => (
//                       <td
//                         key={index}
//                         className={`t-col-${index + 1} ${cell.column.className} ${
//                           priority == "High" ? "highPriority" : ""
//                         }`}
//                         {...cell.getCellProps()}
//                       >
//                         {cell.render("Cell")}
//                       </td>
//                     ))}
//                   </tr>
//                 )
//               })}
//             </tbody>
//           </Table>
//         </div>

//         {/* Pagination */}
//         <Row className="justify-content-md-end justify-content-center align-items-center">
//           <NewPagination
//             gotoPage={gotoPage}
//             canPreviousPag={canPreviousPage}
//             canNextPage={canNextPage}
//             pageIndex={pageIndex}
//             pageOptions={pageOptions}
//             pageSize={pageSize}
//             page={page}
//             data={data}
//           />
//         </Row>
//       </div>
//     )
//   }

// const BankDetails = () => {
// //   const [verticalActiveTab, setverticalActiveTab] = useState("1")

//   const colourStyles = {
//     control: (styles, state) => ({
//       ...styles,
//       backgroundColor: state.isDisabled ? "gray" : "white",
//       // other styles
//     }),
//     // other style properties
//   }

//   const toggleVertical = tab => {
//     if (verticalActiveTab !== tab) {
//       setverticalActiveTab(tab)
//     }
//   }

//   //meta title
//   document.title = "Bank Sheet | Zithas Crm"

//   const [view_customer, setVeiwCustomer] = useState([])
//   const [isLoading, setLoading] = useState(false)

//   const [modal_Access, setAccessDenied] = useState(false)

//   //   document.addEventListener("keydown", e => {
//   //     if (e.key === "Escape")

//   //   })

//   const navigate = useNavigate()

//   // table columns
//   const columns = useMemo(
//     () => [
//       {
//         Header: "Bulk Transaction Type",
//         accessor: "bulk_transaction_type",
//         isInfoIcon: false,
//         isShortIcon: true,
//         className: "text-center bank_bulk_transaction_type",
//       },

//       {
//         Header: "External Ref No",
//         accessor: "ref_no",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "bank_ref_no",
//       },

//       {
//         Header: "Debit Account Number",
//         accessor: "debit_acc",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank_debit_acc",
//       },
//       {
//         Header: "Amount",
//         accessor: "amount",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-amount",
//       },
//       {
//         Header: "Benificiary Name",
//         accessor: "benificiary_name",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-benificiary_name",
//       },
//       {
//         Header: "Benificiary Bank",
//         accessor: "benificiary_bank",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-benificiary_bank",
//       },
//       {
//         Header: "Benificiary Account Number",
//         accessor: "benificiary_account_number",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-benificiary_account_number",
//       },
//       {
//         Header: "IFSC",
//         accessor: "ifsc",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-ifsc",
//       },
//       {
//         Header: "Purpose 1",
//         accessor: "purpose1",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-purpose1",
//       },
//       {
//         Header: "Purpose 2",
//         accessor: "purpose2",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-uil",
//       },
//       {
//         Header: "Cheque Number",
//         accessor: "cheque_number",
//         isInfoIcon: true,
//         isShortIcon: true,
//         className: "text-center bank-cheque_number",
//       },
//     ],
//     []
//   )

//   const data = [
//     {
//         id: 1,
//         name: "Rahul Ovhal",
//         total_days: "25",
//         asl: "0",
//         usl: "0",
//         ael: "0",
//         uel : "0",
//         acl : "0",
//         ucl : "0",
//         uil : "0",
//         lp  : "0",
//         total_leaves : "0",
//         net_leaves : "0",
//         worked_days : "25",
//         amount : "100000"
//     },
//     {
//         id: 2,
//       name: "Kunj",
//         total_days: "25",
//         asl: "0",
//         usl: "0",
//         ael: "0",
//         uel : "0",
//         acl : "0",
//         ucl : "0",
//         uil : "0",
//         lp  : "0",
//         total_leaves : "0",
//         net_leaves : "0",
//         worked_days : "25",
//         amount : "100000"
//     },
//     {
//         id: 3,
//       name: "Yasir",
//       total_days: "25",
//       asl: "0",
//       usl: "0",
//       ael: "0",
//       uel : "0",
//       acl : "0",
//       ucl : "0",
//       uil : "0",
//       lp  : "0",
//       total_leaves : "0",
//       net_leaves : "0",
//       worked_days : "25",
//       amount : "100000"
//     },
//     {
//         id: 4,
//       name: "Zain",
//       total_days: "25",
//       asl: "0",
//       usl: "0",
//       ael: "0",
//       uel : "0",
//       acl : "0",
//       ucl : "0",
//       uil : "0",
//       lp  : "0",
//       total_leaves : "0",
//       net_leaves : "0",
//       worked_days : "25",
//       amount : "100000"
//     },
//     {
//         id: 5,
//         name: "Mayur",
//         total_days: "25",
//         asl: "0",
//         usl: "0",
//         ael: "0",
//         uel : "0",
//         acl : "0",
//         ucl : "0",
//         uil : "0",
//         lp  : "0",
//         total_leaves : "0",
//         net_leaves : "0",
//         worked_days : "25",
//         amount : "100000"
//     },
//     {
//         id: 6,
//       name: "Manav",
//       total_days: "25",
//       asl: "0",
//       usl: "0",
//       ael: "0",
//       uel : "0",
//       acl : "0",
//       ucl : "0",
//       uil : "0",
//       lp  : "0",
//       total_leaves : "0",
//       net_leaves : "0",
//       worked_days : "25",
//       amount : "100000"
//     },
//     {
//         id: 7,
//       name: "Mohit",
//       total_days: "25",
//       asl: "0",
//       usl: "0",
//       ael: "0",
//       uel : "0",
//       acl : "0",
//       ucl : "0",
//       uil : "0",
//       lp  : "0",
//       total_leaves : "0",
//       net_leaves : "0",
//       worked_days : "25",
//       amount : "100000"
//     },
//     {
//         id: 8,
//       name: "Divyansh",
//       total_days: "25",
//       asl: "0",
//       usl: "0",
//       ael: "0",
//       uel : "0",
//       acl : "0",
//       ucl : "0",
//       uil : "0",
//       lp  : "0",
//       total_leaves : "0",
//       net_leaves : "0",
//       worked_days : "25",
//       amount : "100000"
//     },
//   ]

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="page-content">
//         <Container fluid>
//           <Breadcrumbs
//             title={"Payroll management"}
//             breadcrumbItem={"Bank Sheet"}
//           />
//           <Row>
//             <Col lg={12} className="p-0">
//               <Card>
//                 <CardBody>
//                   <div className="responsive-table">
//                     <TableContainer
//                       columns={columns}
//                       data={data}
//                     />
//                   </div>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </div>

//       <AccessDeniedPopup
//         modal_Access={modal_Access}
//         setAccessDenied={setAccessDenied}
//       />
//     </React.Fragment>
//   )
// }

const BankDetails = () => {
  document.title = "Bank Sheet | Zithas Crm"

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 1200,
    }),
  }

  const status_option = [
    { label: "Approved", value: "Approved" },
    { label: "Unapproved", value: "Unapproved" },
    { label: "Cancel", value: "Cancel" },
  ]
  const columns = useMemo(
    () => [
      {
        Header: "Bulk Transaction Type",
        accessor: "bulk_transaction_type",
        isInfoIcon: true,
        isShortIcon: true,
        className: "bank_bulk_transaction_type break-word",
      },

      {
        Header: "External Ref No",
        accessor: "ref_no",
        isInfoIcon: true,
        isShortIcon: true,
        className: "bank_ref_no",
      },

      {
        Header: "Debit Account Number",
        accessor: "debit_acc",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank_debit_acc",
      },
      {
        Header: "Amount",
        accessor: "amount",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-amount",
      },
      {
        Header: "Benificiary Name",
        accessor: "benificiary_name",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-benificiary_name",
      },
      {
        Header: "Benificiary Bank",
        accessor: "benificiary_bank",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-benificiary_bank",
      },
      {
        Header: "Benificiary Account Number",
        accessor: "benificiary_account_number",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-benificiary_account_number",
      },
      {
        Header: "IFSC",
        accessor: "ifsc",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-ifsc",
      },
      {
        Header: "Purpose 1",
        accessor: "purpose1",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-purpose1",
      },
      {
        Header: "Purpose 2",
        accessor: "purpose2",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-uil",
      },
      {
        Header: "Cheque Number",
        accessor: "cheque_number",
        isInfoIcon: true,
        isShortIcon: true,
        className: "text-center bank-cheque_number",
      },
    ],
    []
  )

  const data = [
    {
      bulk_transaction_type: "Net Banking",
      ref_no: "251214552",
      debit_acc: "754544544545",
      amount: "15540",
      benificiary_name: "global infotech",
      benificiary_bank: "National Bank",
      benificiary_account_number: "787978778778",
      ifsc: "ABG7887SF21",
      purpose1: "Business Purpose",
      purpose2: "Business Purpose",
      cheque_number: "123512",
    },
    {
      bulk_transaction_type: "Net Banking",
      ref_no: "251214552",
      debit_acc: "754544544545",
      amount: "15540",
      benificiary_name: "global infotech",
      benificiary_bank: "National Bank",
      benificiary_account_number: "787978778778",
      ifsc: "ABG7887SF21",
      purpose1: "Business Purpose",
      purpose2: "Business Purpose",
      cheque_number: "123512",
    },
    {
      bulk_transaction_type: "Net Banking",
      ref_no: "251214552",
      debit_acc: "754544544545",
      amount: "15540",
      benificiary_name: "global infotech",
      benificiary_bank: "National Bank",
      benificiary_account_number: "787978778778",
      ifsc: "ABG7887SF21",
      purpose1: "Business Purpose",
      purpose2: "Business Purpose",
      cheque_number: "123512",
    },
    {
      bulk_transaction_type: "Net Banking",
      ref_no: "251214552",
      debit_acc: "754544544545",
      amount: "15540",
      benificiary_name: "global infotech",
      benificiary_bank: "National Bank",
      benificiary_account_number: "787978778778",
      ifsc: "ABG7887SF21",
      purpose1: "Business Purpose",
      purpose2: "Business Purpose",
      cheque_number: "123512",
    },
  ]

  return (
    <>
      {/* <div>
          <Row className="ms-0 pe-0">
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <TableContainer columns={columns} data={data} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div> */}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={"Payroll Management"}
            breadcrumbItem={"Bank Details"}
          />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <TableContainer columns={columns} data={data} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default BankDetails
